import { render, staticRenderFns } from "./tab_horizontal.vue?vue&type=template&id=1e026bd2&scoped=true"
import script from "./tab_horizontal.vue?vue&type=script&lang=js"
export * from "./tab_horizontal.vue?vue&type=script&lang=js"
import style0 from "./tab_horizontal.vue?vue&type=style&index=0&id=1e026bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e026bd2",
  null
  
)

export default component.exports